// Get job search alerts list for a user  ***********************
// pathname: /v1/user/job-search-alerts
// **********************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrJobSearchAlertsProps {
  locale?: Locale;
  shouldFetch?: boolean;
  serverData?: ApiSchema<'JobSearchAlertData'>[];
}

/**
 * @description SWR Get job search alerts list for a user.
 * @param props
 */
export const useSwrJobSearchAlerts = (props: UseSwrJobSearchAlertsProps) => {
  const { locale = 'ro', shouldFetch = true, serverData } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'JobSearchAlertData'>[]>({
    url: '/v1/user/job-search-alerts',
    locale,
    shouldFetch,
    serverSideData: serverData,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};

